import React, { useEffect } from 'react';
import { BridgeStateProvider, useBridgeOptions } from './services/BridgeStateContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { EnvProvider } from './providers/EnvContext';
import AppRouting from './AppRouting';

const AppContent = () => {
  const options = useBridgeOptions();

  useEffect(() => {
    console.log('data from native:', options);
    const htmlElement = document.documentElement;
    if (window.shellJsBridgeWebToNative || window.androidJsBridge) {
      if (options.chatMode === true) {
        htmlElement.classList.add('native-webview');        
      } else {
        htmlElement.classList.add('native-webview-nochatmode');
      }
    } else {
      htmlElement.classList.remove('native-webview-nochatmode');
      htmlElement.classList.remove('native-webview');
    }
    return () => {
      htmlElement.classList.remove('native-webview-nochatmode');
      htmlElement.classList.remove('native-webview');
    };
  }, [options]); // rerun if options change (or narrow to options.language)

  return (
    <Router>
      <Routes>
        <Route path="*" element={<AppRouting />} />
      </Routes>
    </Router>
  );
};

const App = () => (
  <BridgeStateProvider>
    <EnvProvider>
      <AppContent />
    </EnvProvider>
  </BridgeStateProvider>
);

export default App;
